var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isFree
    ? _c(
        "w-container",
        { staticClass: "inbox-container", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { staticClass: "sticky-breadcrumb" },
            [
              _c(
                "w-row",
                { attrs: { grow: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "inbox-tabs" },
                    _vm._l(_vm.visibleTabs, function (t) {
                      return _c(
                        "div",
                        {
                          key: t.value,
                          staticClass: "inbox-tab",
                          class: { active: _vm.state.tab == t.value },
                          on: {
                            click: function ($event) {
                              return _vm.setTab(t.value)
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "tab-icon",
                            attrs: { icon: t.icon },
                          }),
                          _c("span", [_vm._v(_vm._s(t.text))]),
                          _c(
                            "span",
                            {
                              staticClass: "tab-count",
                              class: { loading: !t.showCount },
                            },
                            [_vm._v(_vm._s(t.showCount ? t.count : ""))]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c("w-spacer"),
                  _vm.dossierConfig.peppolRegistrationStatus == 2 &&
                  _vm.registrations.length > 0
                    ? _c(
                        "div",
                        { staticClass: "peppol-id-pill" },
                        [
                          _c("w-fa", {
                            staticClass: "pill-check",
                            attrs: { icon: "check" },
                          }),
                          _c("span", { staticClass: "pill-label" }, [
                            _vm._v(_vm._s(_vm.$ct("peppol-id"))),
                          ]),
                          _vm.displayedPeppolId
                            ? [
                                _c("span", { staticClass: "pill-id" }, [
                                  _vm._v(_vm._s(_vm.displayedPeppolId)),
                                ]),
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("copy"),
                                        expression: "$ct('copy')",
                                      },
                                    ],
                                    staticClass: "pill-copy",
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(_vm.displayedPeppolId)
                                      },
                                    },
                                  },
                                  [
                                    _c("w-fa", {
                                      attrs: { icon: ["far", "copy"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm.displayedPeppolIdIsSendOnly
                            ? _c(
                                "span",
                                { staticClass: "send-only-warning" },
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "info-circle" },
                                  }),
                                  _vm._v(" " + _vm._s(_vm.$ct("send-only"))),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { staticClass: "content-row" },
            [
              _vm.isAdmin &&
              _vm.showsPeppolDocuments &&
              _vm.dossierConfig.peppolRegistrationStatus < 2
                ? _c(
                    "w-card-content",
                    [
                      _c(
                        "w-info",
                        { staticClass: "infobox-extra", attrs: { text: "" } },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.peppolMsg,
                                expression: "peppolMsg",
                              },
                            ],
                          }),
                          _c("w-spacer"),
                          _vm.dossierConfig.peppolRegistrationStatus == 0 &&
                          _vm.isOwner
                            ? _c(
                                "w-button",
                                {
                                  staticClass: "ml",
                                  on: {
                                    click: function ($event) {
                                      _vm.showRegistration = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("peppol-start")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAdmin &&
              _vm.showsPeppolDocuments &&
              _vm.dossierConfig.peppolRegistrationStatus == 2 &&
              !_vm.showToProcessFiles
                ? _c(
                    "w-card-content",
                    [
                      _c(
                        "w-info",
                        {
                          staticClass: "infobox-extra green",
                          attrs: {
                            text: "",
                            "ico-lib": "fas",
                            ico: "info-circle",
                          },
                        },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.$ct("peppol-msg-3"),
                                expression: "$ct('peppol-msg-3')",
                              },
                            ],
                          }),
                          _c("w-spacer"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-breadcrumb",
                {
                  style: {
                    width: "100%",
                    paddingTop: "10px",
                    paddingBottom: "0",
                    borderBottom: "none !important",
                  },
                },
                [
                  _c(
                    "w-scroll-view",
                    {
                      staticClass: "breadcrumb-content",
                      attrs: { x: "", y: false, tag: "w-row" },
                    },
                    [
                      _c("w-select", {
                        staticClass: "view-select",
                        attrs: {
                          items: _vm.archiveItems,
                          "empty-text": _vm.$ct("none"),
                          filter: "",
                        },
                        model: {
                          value: _vm.state.archive,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "archive", $$v)
                          },
                          expression: "state.archive",
                        },
                      }),
                      _c("w-input", {
                        staticClass: "search-input ml",
                        attrs: {
                          placeholder: _vm.$ct("search-placeholder"),
                          clearable: "",
                          icon: "search",
                        },
                        model: {
                          value: _vm.state.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "search", $$v)
                          },
                          expression: "state.search",
                        },
                      }),
                      _c("w-spacer"),
                      _c(
                        "w-button-bar",
                        { staticClass: "ml" },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("view-cards"),
                                  expression: "$ct('view-cards')",
                                },
                              ],
                              class: { cancel: _vm.state.view == "grid" },
                              on: {
                                click: function ($event) {
                                  return _vm.state.setView("grid")
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "th" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("view-list"),
                                  expression: "$ct('view-list')",
                                },
                              ],
                              class: { cancel: _vm.state.view == "list" },
                              on: {
                                click: function ($event) {
                                  return _vm.state.setView("list")
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "list" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("view-split"),
                                  expression: "$ct('view-split')",
                                },
                              ],
                              class: { cancel: _vm.state.view == "split" },
                              on: {
                                click: function ($event) {
                                  return _vm.state.setView("split")
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "columns" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-button-bar",
                        { staticClass: "mls" },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("manage-labels"),
                                  expression: "$ct('manage-labels')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  _vm.showLabelsModal = true
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "tags" } })],
                            1
                          ),
                          _vm.canUpload
                            ? _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("upload-documents"),
                                      expression: "$ct('upload-documents')",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.showUploadModal = true
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "cloud-upload-alt" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.state.labels.length || _vm.showSourceChips
                ? _c(
                    "div",
                    { staticClass: "label-filter-bar" },
                    [
                      _vm.showSourceChips
                        ? [
                            _vm._l(_vm.sourceFilters, function (source) {
                              return _c(
                                "span",
                                {
                                  key: source.value,
                                  staticClass: "filter-chip source-chip",
                                  class: { active: source.active },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSource(source.value)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(source.text) + " ")]
                              )
                            }),
                            _vm.state.labels.length
                              ? _c("span", { staticClass: "chip-divider" })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._l(_vm.visibleFilterLabels, function (l) {
                        return _c(
                          "span",
                          {
                            key: l.ID,
                            staticClass: "filter-chip",
                            class: {
                              active: _vm.state.selectedLabelIds.includes(l.ID),
                            },
                            style: _vm.state.selectedLabelIds.includes(l.ID)
                              ? _vm.activeChipStyle(l)
                              : undefined,
                            on: {
                              click: function ($event) {
                                return _vm.state.toggleLabelFilter(l.ID)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "dot",
                              style: { backgroundColor: l.Color },
                            }),
                            _vm._v(" " + _vm._s(l.Name) + " "),
                          ]
                        )
                      }),
                      !_vm.labelsExpanded && _vm.hiddenLabelCount > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "filter-chip more-chip",
                              on: {
                                click: function ($event) {
                                  _vm.labelsExpanded = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$ct("x-more", {
                                      count: _vm.hiddenLabelCount,
                                    })
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm.labelsExpanded &&
                          _vm.state.labels.length > _vm.labelFilterLimit
                        ? _c(
                            "span",
                            {
                              staticClass: "filter-chip more-chip",
                              on: {
                                click: function ($event) {
                                  _vm.labelsExpanded = false
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("show-less")) + " ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "list-area" },
                [
                  _vm.showSelectionBar
                    ? _c(
                        "div",
                        {
                          staticClass: "selection-bar",
                          class: _vm.state.barPosition,
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "selection-bar-inner" },
                            [
                              _c("span", { staticClass: "selection-count" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("selected-count", {
                                      count: _vm.selectionCount,
                                    })
                                  )
                                ),
                              ]),
                              _vm.selectionCount
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("clear-selection"),
                                          expression: "$ct('clear-selection')",
                                        },
                                      ],
                                      staticClass: "selection-close",
                                      on: {
                                        click: function ($event) {
                                          return _vm.state.clearSelection()
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "times" } })],
                                    1
                                  )
                                : _vm._e(),
                              _c("span", { staticClass: "selection-sep" }),
                              _vm.state.labels.length
                                ? _c(
                                    "w-dropdown",
                                    {
                                      attrs: {
                                        flat: "",
                                        disabled: !_vm.selectionCount,
                                        up: _vm.state.barPosition == "bottom",
                                        icon: "tag",
                                        items: _vm.labelMenuItems,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.bulkAssignLabel($event)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$ct("label")) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "w-button",
                                {
                                  attrs: {
                                    flat: "",
                                    disabled:
                                      _vm.bulkProcessing || !_vm.selectionCount,
                                  },
                                  on: { click: _vm.downloadSelection },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "download" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$ct("download-selection")) + " "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-button",
                                {
                                  attrs: {
                                    flat: "",
                                    disabled:
                                      _vm.bulkProcessing ||
                                      !_vm.canForwardSelection,
                                  },
                                  on: { click: _vm.forwardSelection },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "share" },
                                  }),
                                  _vm._v(_vm._s(_vm.$ct("forward")) + " "),
                                ],
                                1
                              ),
                              _c(
                                "w-button",
                                {
                                  attrs: {
                                    flat: "",
                                    disabled:
                                      _vm.bulkProcessing || !_vm.selectionCount,
                                  },
                                  on: { click: _vm.archiveSelection },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "archive" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$ct("archive-documents")) + " "
                                  ),
                                ],
                                1
                              ),
                              _vm.canApprove
                                ? _c(
                                    "w-button",
                                    {
                                      attrs: {
                                        flat: "",
                                        disabled: !_vm.selectionCount,
                                      },
                                      on: { click: _vm.toggleApproval },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: { icon: "check" },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectionHasApprovedFiles
                                            ? _vm.$ct("unapprove-documents")
                                            : _vm.$ct("approve-documents")
                                        ) + " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isSelfBillingItemSelected
                                ? [
                                    _c(
                                      "w-button",
                                      {
                                        staticClass: "mls danger",
                                        attrs: {
                                          disabled:
                                            _vm.creating ||
                                            !_vm.hasSelfBillingModule,
                                        },
                                        on: { click: _vm.rejectSelfBilledSale },
                                      },
                                      [_vm._v(_vm._s(_vm.$ct("reject-sale")))]
                                    ),
                                    _c(
                                      "w-button",
                                      {
                                        staticClass: "mls",
                                        attrs: {
                                          disabled:
                                            _vm.creating ||
                                            !_vm.hasSelfBillingModule,
                                        },
                                        on: { click: _vm.createSelfBilledSale },
                                      },
                                      [_vm._v(_vm._s(_vm.$ct("create-sale")))]
                                    ),
                                  ]
                                : _c(
                                    "w-button",
                                    {
                                      staticClass: "mls",
                                      attrs: {
                                        disabled:
                                          _vm.creating ||
                                          _vm.selectionHasUnapprovedFiles ||
                                          !_vm.selectionCount,
                                      },
                                      on: { click: _vm.create },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: { icon: "cart-plus" },
                                      }),
                                      _vm._v(_vm._s(_vm.buttonText) + " "),
                                    ],
                                    1
                                  ),
                              _c(
                                "w-dropdown",
                                {
                                  staticClass: "selection-menu",
                                  attrs: {
                                    flat: "",
                                    right: "",
                                    up: _vm.state.barPosition == "bottom",
                                    items: _vm.barPositionItems,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.state.setBarPosition($event)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.uploadJob.uploading && _vm.state.view != "grid"
                    ? _c("app-upload-queue-bar")
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "scroll-container" },
                    [
                      _vm.showToProcessFiles && _vm.state.view == "split"
                        ? _c("app-inbox-split-view", {
                            attrs: { state: _vm.state },
                            on: {
                              "send-mail": function ($event) {
                                return _vm.openSendModal($event)
                              },
                              refresh: function ($event) {
                                return _vm.state.fetchPurchases()
                              },
                              create: function ($event) {
                                return _vm.create()
                              },
                            },
                          })
                        : _vm.showToProcessFiles
                        ? _c("app-to-process-files", {
                            attrs: {
                              state: _vm.state,
                              grid: _vm.state.view == "grid",
                              "type-state": _vm.state.selectedType,
                              "can-upload": _vm.canUpload,
                            },
                            on: {
                              "send-mail": function ($event) {
                                return _vm.openSendModal($event)
                              },
                              "refresh-delete": function ($event) {
                                return _vm.state.fetchPurchases()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  staticClass: "w100 preview",
                  attrs: {
                    value: _vm.state.preview != null,
                    "full-height": "",
                    "escape-close": "",
                  },
                },
                [
                  _c("app-email-preview", {
                    attrs: { state: _vm.state },
                    on: {
                      close: function ($event) {
                        _vm.state.preview = null
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  staticClass: "w100 preview",
                  attrs: {
                    value: _vm.state.edit != null,
                    "full-height": "",
                    "escape-close": "",
                  },
                },
                [
                  _c("app-edit-purchase", {
                    ref: "root",
                    attrs: { "purchase-from-inbox": _vm.state.edit },
                    on: {
                      update: function ($event) {
                        return _vm.state.fetchPurchases()
                      },
                      close: function ($event) {
                        ;(_vm.state.edit = null), _vm.state.clearSelection()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.showRegistration,
                    callback: function ($$v) {
                      _vm.showRegistration = $$v
                    },
                    expression: "showRegistration",
                  },
                },
                [
                  _c("app-peppol-registration-modal", {
                    on: {
                      close: function ($event) {
                        _vm.showRegistration = false
                      },
                      update: function ($event) {
                        return _vm.updatePeppolStatus()
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.showLabelsModal
                ? _c("app-inbox-labels-modal", {
                    on: {
                      close: function ($event) {
                        _vm.showLabelsModal = false
                      },
                      updated: function ($event) {
                        return _vm.onLabelsUpdated()
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.showUploadModal,
                    callback: function ($$v) {
                      _vm.showUploadModal = $$v
                    },
                    expression: "showUploadModal",
                  },
                },
                [
                  _vm.showUploadModal
                    ? _c("app-upload-purchase-modal", {
                        on: {
                          close: function ($event) {
                            _vm.showUploadModal = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.sendMailDialogOpened,
                    callback: function ($$v) {
                      _vm.sendMailDialogOpened = $$v
                    },
                    expression: "sendMailDialogOpened",
                  },
                },
                [
                  _vm.sendMailDialogOpened
                    ? _c("app-send-message-dialog", {
                        attrs: {
                          attachements: _vm.downloadedFiles,
                          content: _vm.mailContent,
                          subject: _vm.mailSubject,
                          to: _vm.mailTo,
                          title: _vm.$ct("mail.mail-title"),
                        },
                        on: {
                          close: function ($event) {
                            _vm.sendMailDialogOpened = false
                          },
                          sent: function ($event) {
                            _vm.sendMailDialogOpened = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }